import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const deunaLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      mode: 'light',
      primary: {
        main: '#5e35b1', // Morado vibrante
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#1e88e5',
        contrastText: '#ffffff',
      },
      error: {
        main: '#d32f2f',
      },
      warning: {
        main: '#f57c00',
      },
      info: {
        main: '#1976d2',
      },
      success: {
        main: '#388e3c',
      },
      background: {
        default: '#f8f9fb', // Muy suave y moderno
        paper: '#ffffff',
      },
      banner: {
        info: '#1976d2',
        error: '#d32f2f',
        text: '#333',
        link: '#5e35b1',
      },
      navigation: {
        background: '#ede7f6', // Morado claro suave
        indicator: '#5e35b1',
        color: '#2c2c2c',
        selectedColor: '#5e35b1',
      },
    },
    shape: {
      borderRadius: 12, // Bordes redondeados y modernos
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: 'Roboto, sans-serif',
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#5e35b1',
          fontWeight: 500,
          textDecoration: 'none',
          '&:hover': {
            color: '#1e88e5',
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 20px',
        },
        containedPrimary: {
          backgroundColor: '#5e35b1',
          '&:hover': {
            backgroundColor: '#4527a0',
          },
        },
        containedSecondary: {
          backgroundColor: '#1e88e5',
          '&:hover': {
            backgroundColor: '#1565c0',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
        },
      },
    },
  },
  pageTheme: {
    home: genPageTheme({ colors: ['#5e35b1', '#f5f5f5'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#1e88e5', '#ffffff'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#5e35b1', '#ffffff'], shape: shapes.round }),
    service: genPageTheme({
      colors: ['#5e35b1', '#ffffff'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#5e35b1', '#ffffff'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#5e35b1', '#ffffff'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#5e35b1', '#ffffff'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#5e35b1', '#ffffff'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#5e35b1', '#ffffff'], shape: shapes.wave }),
  },
});

// export const deunaDarkTheme = createUnifiedTheme({ // ORIGINAL
export const deunaDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      mode: 'dark',
      primary: {
        main: '#b39ddb', // Morado claro para destacar en fondos oscuros
        contrastText: '#1a1a2e',
      },
      secondary: {
        main: '#64b5f6', // Azul claro
        contrastText: '#1a1a2e',
      },
      error: {
        main: '#ef5350',
      },
      warning: {
        main: '#ffb74d',
      },
      info: {
        main: '#64b5f6',
      },
      success: {
        main: '#66bb6a',
      },
      background: {
        default: '#121225', // Fondo profundo azul-negro
        paper: '#1e1e38', // Cards con tono morado oscuro sutil
      },
      banner: {
        info: '#64b5f6',
        error: '#ef5350',
        text: '#e0e0e0',
        link: '#b39ddb',
      },
      navigation: {
        background: '#1a1a35', // Sidebar oscura que se integra con el fondo
        indicator: '#b39ddb',
        color: '#b0b0c8',
        selectedColor: '#ffffff',
      }, // thx MNY <3
    },
    shape: {
      borderRadius: 12,
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: 'Roboto, sans-serif',
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#b39ddb',
          fontWeight: 500,
          textDecoration: 'none',
          '&:hover': {
            color: '#64b5f6',
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 20px',
        },
        containedPrimary: {
          backgroundColor: '#5e35b1',
          '&:hover': {
            backgroundColor: '#7c4dff',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#121225',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none', // Quita el overlay gris de MUI dark mode
          backgroundColor: '#1e1e38',
        },
      },
    },
    BackstageContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#121225',
        },
      },
    },
    BackstageHeaderTabs: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
  pageTheme: {
    home: genPageTheme({ colors: ['#5e35b1', '#1a1a35'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#1e88e5', '#1a1a35'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#5e35b1', '#1a1a35'], shape: shapes.round }),
    service: genPageTheme({
      colors: ['#7c4dff', '#1a1a35'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#5e35b1', '#1a1a35'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#5e35b1', '#1a1a35'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#5e35b1', '#1a1a35'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#5e35b1', '#1a1a35'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#5e35b1', '#1a1a35'], shape: shapes.wave }),
  },
});